function deepEqual(obj1: { [x: string]: any }, obj2: { [x: string]: any }) {
	if (obj1 === obj2) {
		return true;
	}

	if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
		return false;
	}

	const keys1 = Object.keys(obj1);
	const keys2 = Object.keys(obj2);

	if (keys1.length !== keys2.length) {
		return false;
	}

	for (const key of keys1) {
		if (!keys2.includes(key)) {
			return false;
		}
		if (!deepEqual(obj1[key], obj2[key])) {
			return false;
		}
	}

	return true;
}

/**
 * Compare two arrays of deeply nested objects with recursive comparison
 * @param {string | any[]} arr1 - First array to compare
 * @param {string | any[]} arr2 - Second array to compare
 * @returns {boolean} - Returns true if the arrays are equal, otherwise false
 */
export default function areArraysOfObjectEqual(
	arr1: string | any[],
	arr2: string | any[]
): boolean {
	if (arr1.length !== arr2.length) {
		return false;
	}

	for (let i = 0; i < arr1.length; i++) {
		// Shallow comparison of the main object properties
		if (
			arr1[i].value !== arr2[i].value ||
			arr1[i].text !== arr2[i].text ||
			arr1[i].key !== arr2[i].key
		) {
			return false;
		}

		// Deep comparison of nested objects
		if (!deepEqual(arr1[i].externalData, arr2[i].externalData)) {
			return false;
		}
	}

	return true;
}
